/**
 * @class Tab
 */
export default class Tab {
    /**
     * @param {Number}          id
     * @param {String}          name
     * @param {String}          type
     * @param {String | null}   color
     * @param {Number}          order
     * @param {String | null}   scene
     * @param {String | null}   headerClass
     * @param {String | null}   bodyClass
     */
    constructor(id, name, type, color, order, scene = null, headerClass = null, bodyClass = null) {
        this._id = id;
        this._name = name !== null && name.length > 25 ? name.substr(0, 23) + "..." : name;
        this._type = type;
        this._color = color;
        this._order = order;
        this._scene = scene;
        this._headerClass = headerClass === undefined ? "" : headerClass;
        this._bodyClass = bodyClass === undefined ? "" : bodyClass;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Tab");
        }

        if (this._type === null) {
            throw new Error("Invalid value of type - Tab");
        }

        if (typeof this._type !== "string") {
            throw new Error("Invalid datatype of type - Tab");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name !== null && name.length > 25 ? name.substr(0, 23) + "..." : name;
    }

    /**
     * @return {String}
     */
    get type() {
        return this._type;
    }

    /**
     * @param {String} type
     */
    set type(type) {
        this._type = type;
    }

    /**
     * @return {String | null}
     */
    get color() {
        return this._color;
    }

    /**
     * @param {String | null}   color
     */
    set color(color) {
        this._color = color;
    }

    /**
     * @return {Number}
     */
    get order() {
        return this._order;
    }

    /**
     * @param {Number} order
     */
    set order(order) {
        this._order = order;
    }

    /**
     * @return {String | null}
     */
    get scene() {
        return this._scene;
    }

    /**
     * @param {String | null}   scene
     */
    set scene(scene) {
        this._scene = scene;
    }

    /**
     * @return {String}
     */
    get headerClass() {
        return this._headerClass;
    }

    /**
     * @param {String} order
     */
    set headerClass(headerClass) {
        this._headerClass = headerClass;
    }

    /**
     * @return {String}
     */
    get bodyClass() {
        return this._bodyClass;
    }

    /**
     * @param {String} bodyClass
     */
    set bodyClass(bodyClass) {
        this._bodyClass = bodyClass;
    }

    /**
     * @return {Object}
     */
    clone() {
        return new Tab(
            this._id,
            this._name,
            this._type,
            this._color,
            this._order,
            this._scene,
            this._headerClass,
            this._bodyClass
        );
    }

    /**
     * @param   {String}        name
     * @param   {String | null} color
     * @return  {Object}
     */
    updateNameAndColor = (name, color) => {
        let tab = this.clone();
        tab.name = name;
        tab.color = color;

        return tab;
    };

    /**
     * @param   {Number}    order
     * @return  {Object}
     */
    updateOrder = (order) => {
        let tab = this.clone();
        tab.order = order;

        return tab;
    };

    /**
     * @param   {String | null} scene
     * @return  {Object}
     */
    updateScene = (scene) => {
        let tab = this.clone();
        tab.scene = scene;

        return tab;
    };

    /**
     * @param   {String | null} name
     * @param   {String | null} color
     * @param   {String | null} scene
     * @return  {Object}
     */
    updateData = (name, color, scene) => {
        let tab = this.clone();

        if (name !== null) {
            tab.name = name;
        }

        if (color !== null) {
            tab.color = color;
        }

        if (scene !== null) {
            tab.scene = scene;
        }

        return tab;
    };

    /**
     * @return {String}
     */
    toString() {
        return "Tab (" + this._id + ")";
    }
}
